<template>
  <div class="week-table table-responsive-xxl" >
    <table class="table ">
      <thead class="thead">
      <tr>
        <th class="date-heading" v-for="day in weeksDates" :key="day">
          <a class="btn btn-dark-gary btn-sm">
            {{day}}
            <i @click="copyShiftByDateFun(day)" v-show="isCopyByDate==false"
               class="ico-Copy icoCopyByDate" title="Copy schedules by date"></i>
          </a>
        </th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td class="schedule-td" v-for="(day,keyIndex) in weeksDates" :keyIndex="day"
        >
          <div class="inner-td-wrp">
            <div class="copy-days" v-show="isCopyByDate==true">
              <div class="text-wrap" @click="pasteShiftByDateFun(day)">
                <h6>Paste this day</h6>
                <a href="javascript:void(0)">Click here to Paste
                  this day</a>
              </div>
            </div>
            <div>
              <div class="card-wrapper" v-for="(info,index) in newarrayTemplate[day]" :keyIndex="info">
                <div>
                  <input type="hidden" :class="'start_time'+[day]+[index]" :value="info.start_time">
                  <input type="hidden" :class="'end_time'+[day]+[index]" :value="info.end_time">
                  <input type="hidden" :class="'employee_id'+[day]+[index]" :value="info.employee_id">
                  <input type="hidden" :class="'job_role_id'+[day]+[index]" :value="info.job_role_id">
                  <input type="hidden" :class="'break_time'+[day]+[index]" :value="info.break_time">
                  <input type="hidden" :class="'comment'+[day]+[index]" :value="info.comment">
                </div>

                <time datetime="2021-12-15 15:00">
                  {{info.start_time}} - {{info.end_time}}
                </time>
                <div class="mini-card border-gray">
                  <div class="card-body">
                    <h4>{{info.jobRole.name }}</h4>
                    <span class="emp-designation"><i
                            class="ico ico-fill-circle cyan"></i>
                                {{info.employee.name }}</span>
                  </div>
                  <div class="overlayer-btn">
                    <ul>
                      <li>
                        <a href="#" class="over-btn" @click.stop.prevent="shiftCopyFun(day,index)"
                           v-show="isCopy==false"><i class="ico-Copy"></i></a>
                      </li>
                      <li>
                        <a class="over-btn" data-toggle="collapse" @click=editSchedule(info.id)
                           :href="'#shift-dropdown-edit'+index+'-'+day" role="button"
                           aria-expanded="false" aria-controls="shift-dropdown"><i
                                class="ico-pencil"></i></a>
                      </li>
                    </ul>
                  </div>


                  <div class="shift-dropmenu collapse" v-show="isEditModalVisible"
                       :id="'shift-dropdown-edit'+index+'-'+day">
                    <div class="drop-header">
                      <div class="drop-title ">
                        <h5>Set Times</h5>
                      </div>
                      <a data-toggle="collapse" class="close"
                         href="#shift-dropdown102" role="button"
                         aria-expanded="false" aria-controls="shift-dropdown">
                        <span class="ico-cross"></span>
                      </a>

                    </div>
                    <div class="drop-body">

                      <div class="inputs-wrapper">
                        <div class="inputs-holder">
                          <div class="field-col">
                            <label>Punch In</label>
                            <input type="time" v-model="scheduleForm.start_time" class="form-control"
                                   value="14:00">
                          </div>
                          <div class="field-col">
                            <label>Punch Out</label>
                            <input type="time" v-model="scheduleForm.end_time" class="form-control"
                                   value="22:00">
                          </div>
                          <div class="field-col">
                            <label for="exampleFormControlSelect1">Break Time</label>
                            <div class="nav-selectdrop">
                              <select class="form-control  " v-model="scheduleForm.break_time">
                                <option selected="" :value="20">20 Min</option>
                                <option :value="30">30 Min</option>
                                <option :value="40">40 Min</option>
                                <option :value="60">60 Min</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div class="inputs-holder">
                          <div class="field-col">
                            <label>Job Role</label>
                            <div class="nav-selectdrop">
                              <select class="form-control" v-model="scheduleForm.job_role_id">
                                <option v-if="jobTypes.length>0" v-for="value in jobTypes" :value="value.id">
                                  {{value.name}}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="field-col">
                            <label>Employee</label>
                            <div class="nav-selectdrop">
                              <select id="inputState" class="form-control" v-model="scheduleForm.employee_id"
                                      readonly>
                                <option v-if="jobTypesEmployees.length>0" v-for="value in jobTypesEmployees"
                                        :value="value.employee.id">{{value.employee.name}}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="field-col">
                            <label>Note (optional)</label>
                            <input type="text" v-model="scheduleForm.comment" class="form-control"
                                   value="Add a Note ...">
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="drop-footer">
                      <button class="btn btn-outline-primary btn-sm" @click="deleteSchedule(info.id)">Delete
                      </button>
                      <button class="btn btn-outline-primary btn-sm" @click="updateTemplate(info.id,day)">Save
                      </button>
                    </div>
                  </div>
                </div>
              </div>


              <div class="card-wrapper cardWrapperCus" v-show="isCopy==true">
                <div class="mini-card border-gray " style="padding:10px">
                  <div class="text-wrap">

                    <h6 class="p-4">Paste This schedule</h6>
                    <button class="btn" @click="shiftPasteFunc(day)">Click here to paste
                      to this schedule
                    </button>
                  </div>

                </div>
              </div>


              <div class="shift-dropdown">
                <a class="btn btn-outline-primary btn-sm" data-toggle="collapse" @click="addShiftBtn"
                   :href="'#shift-dropdown-' + keyIndex"
                   role="button" aria-expanded="false" aria-controls="shift-dropdown">
                  Add shift
                </a>

                <div class="shift-dropmenu collapse" v-show="isModalVisible" :id="'shift-dropdown-' + keyIndex">
                  <form v-on:submit.prevent="submitForm">
                    <div class="drop-header">
                      <div class="drop-title ">
                        <h5>Set Times</h5>
                      </div>
                      <a data-toggle="collapse" @click="closeModalBtn" class="close"
                         :href="'#shift-dropdown-'+ keyIndex"
                         role="button" aria-expanded="false"
                         aria-controls="shift-dropdown">
                        <span class="ico-cross"></span>
                      </a>
                    </div>
                    <div class="drop-body">

                      <div class="inputs-wrapper">
                        <div class="inputs-holder">
                          <div class="field-col">
                            <label>Start Time</label>
                            <input type="time" v-model="scheduleForm.start_time" class="form-control"
                                   value="14:00">
                          </div>
                          <div class="field-col">
                            <label>End Time</label>
                            <input type="time" v-model="scheduleForm.end_time" class="form-control" value="22:00">
                          </div>
                          <div class="field-col">
                            <label for="exampleFormControlSelect1">Break Time</label>
                            <div class="nav-selectdrop">
                              <select id="exampleFormControlSelect1" v-model="scheduleForm.break_time"
                                      class="form-control  ">
                                <option :value="20">20 Min</option>
                                <option :value="30">30 Min</option>
                                <option :value="40">40 Min</option>
                                <option :value="60">60 Min</option>
                              </select>
                            </div>
                          </div>
                        </div>

                        <div class="inputs-holder">
                          <div class="field-col">
                            <label for="job-role">Job Roles</label>
                            <div class="nav-selectdrop">
                              <select id="job-role" v-model="scheduleForm.job_role_id"
                                      @change="getEmployeeByJobRole($event)" class="form-control  ">
                                <option>Select</option>
                                <option v-if="jobTypes.length>0" v-for="value in jobTypes" :value="value.id">
                                  {{value.name}}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="field-col">
                            <label for="employee">Employee</label>
                            <div class="nav-selectdrop">
                              <select id="employee" v-model="scheduleForm.employee_id" class="form-control  ">
                                <option v-if="jobTypesEmployees.length>0" v-for="value in jobTypesEmployees"
                                        :value="value.employee.id">{{value.employee.name}}
                                </option>
                              </select>
                            </div>
                          </div>
                          <div class="field-col">
                            <label>Note (optional)</label>
                            <input type="text" v-model="scheduleForm.comment" class="form-control"
                                   value="Add a Note ...">
                          </div>
                        </div>
                      </div>
                    </div>
                  </form>
                  <div class="drop-footer">
                    <button  class="btn btn-outline-primary btn-sm" @click="addAnotherShiftFun(day)">add another
                      shift</button>
                    <button @click="shiftSaveFunc(day)" class="btn btn-outline-primary btn-sm">Save
                    </button>
                  </div>
                </div>
              </div>
            </div>


          </div>

        </td>


      </tr>


      </tbody>
    </table>
  </div>

</template>
<script>

  import moment from 'moment'
  import router from '../../router/router'
  import axios from "axios";

  export default {
    name: 'signup',



    data() {
      return {
          templateView:false,
          template_id:'',
          company_id: this.$store.getters.getSelectedCompany.id,
        isCopy: false,
        isPaste: false,
        isCopyByDate: false,
        isPasteByDate: false,
        isModalVisible: false,
        isEditModalVisible: false,
        date: new Date(),
        otherdate: new Date(),
        schedule: [],
          weeksDates: ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'],
        newarrayTemplate: [],
          jobTypes: [],
        jobTypesEmployees: [],
        copyTemplateByDateArray: [],
          schedule_ids: [],
          scheduleForm: {
          date: '',
          start_time: '',
          end_time: '',
          break_time: '',
          job_role_id: '',
          employee_id: '',
          company_id: this.$store.getters.getSelectedCompany.id,
          comment: '',
        },

      }
    },

    serverPrefetch() {

    },
    created() {
       this.weeksDatesFun();
        this.getJobType();
        this.getAll();

    },
  mounted() {

    },

    methods: {
        weeksDatesFun(){
            this.weeksDates= ['Mon','Tue','Wed','Thu','Fri','Sat','Sun'];
        },
        getJobType() {
            axios
                .get(this.$GetJobRulesType, {
                    headers: this.getAuthHeader(),
                    params: {
                        company_id: this.company_id,
                    }
                })
                .then(res => {
                    if (res.data.status == 200) {
                        this.allJobTypes = res.data.result;
                        this.jobTypes = this.allJobTypes;
                    }
                });
        },
        getEmployeeByJobRole(event) {
            this.jobTypesEmployees=[];
            axios.get(this.$GetEmployeesByJobRulesType, {
                headers: this.getAuthHeader(),
                params: {
                    job_role_id: event.target.value,
                    company_id: this.company_id,
                }
            })
                .then(res => {
                    if (res.data.status == 200) {
                        this.jobTypesEmployees = res.data.result;
                    }
                });
        },
        closeModalBtn() {
            this.isModalVisible = false;
        },
        addShiftBtn() {
            this.jobTypesEmployees=[];
            this.scheduleForm.date = "";
            this.scheduleForm.start_time = '';
            this.scheduleForm.end_time = '';
            this.scheduleForm.break_time = '';
            this.scheduleForm.job_role_id = '';
            this.scheduleForm.employee_id = '';
            this.scheduleForm.company_id = '';
            this.scheduleForm.comment = '';
            this.isModalVisible = true;
        },
        shiftSaveFunc(date) {
            this.scheduleForm.date = date;
            this.submitForm();
        },

        addAnotherShiftFun(day) {
            this.scheduleForm.date = day;
            this.submitForm();
            this.isModalVisible = true;
        },
        // all schedules of date
        copyShiftByDateFun(day) {
            this.isCopyByDate = true;
            this.isPasteByDate = true;
            let params = {
                company_id: this.company_id,
                day: day,
            };
            this.$axios.get(this.$TemplateByDay, {
                params: params,
                headers: this.getAuthHeader(),
            }).then(response => {
                this.schedule = response.data.result.tempaltes;
              //  console.log(response.data.result.tempaltes);
                this.copyTemplateByDateArray = [];
                this.schedule.forEach(sc => {
                    this.copyTemplateByDateArray.push(sc);
                });
            }).catch(error => {
                console.log(error);
            });
            //console.log('mainend');
        },
        pasteShiftByDateFun(day) {
            this.isCopyByDate = false;
            this.isPasteByDate = false;

            this.copyTemplateByDateArray.forEach(sc => {
                this.scheduleForm.day = day;
                axios.post(this.$Template,
                    {
                        day: day,
                        start_time: sc.start_time,
                        end_time: sc.end_time,
                        break_time: sc.break_time,
                        job_role_id: sc.job_role_id,
                        employee_id: sc.employee_id,
                        company_id: sc.company_id,
                        comment: sc.comment,
                    }
                    , {headers: this.getAuthHeader()})
                    .then((res) => {
                        if (res.status == 200) {
                            this.isCopyByDate = false;
                            this.isPasteByDate = false;
                            this.getAll();
                        }
                        //Perform Success Action
                    })
                    .catch((error) => {
                        // error.response.status Check status code
                    }).finally(() => {
                    //Perform action in always
                });

            });
        },
        submitForm() {
            axios.post(this.$Template,
                {
                    day: this.scheduleForm.date,
                    start_time: this.scheduleForm.start_time,
                    end_time: this.scheduleForm.end_time,
                    break_time: this.scheduleForm.break_time,
                    job_role_id: this.scheduleForm.job_role_id,
                    employee_id: this.scheduleForm.employee_id,
                    company_id: this.company_id,
                    comment: this.scheduleForm.comment,
                }, {headers: this.getAuthHeader()})
                .then((res) => {
                    if (res.status == 200) {
                        this.isModalVisible = false;
                        this.scheduleForm = {};
                        this.template_id = res.data.result.id;
                        this.getAll();
                        return;
                    }

                    //Perform Success Action
                })
                .catch((error) => {
                    // error.response.status Check status code
                }).finally(() => {
                //Perform action in always
            });
        },
        shiftCopyFun(date, key) {
           // console.log(date,key,'date=key');
            this.isCopy = true;
            this.isPasye = true;
            this.scheduleForm.company_id = this.company_id;
            this.scheduleForm.start_time = document.querySelectorAll('.start_time' + date + key)[0].value;
            this.scheduleForm.end_time = document.querySelectorAll('.end_time' + date + key)[0].value;
            this.scheduleForm.employee_id = document.querySelectorAll('.employee_id' + date + key)[0].value;
            this.scheduleForm.job_role_id = document.querySelectorAll('.job_role_id' + date + key)[0].value;
            this.scheduleForm.break_time = document.querySelectorAll('.break_time' + [date + key])[0].value;
            this.scheduleForm.comment = document.querySelectorAll('.comment' + [date + key])[0].value;
        },
        // paste function
        shiftPasteFunc(date) {
            this.isCopy = false;
            this.isPasye = false;
            this.scheduleForm.day = date;
            axios.post(this.$Template, this.scheduleForm
                , {headers: this.getAuthHeader()})
                .then((res) => {
                    if (res.status == 200) {
                        this.getAll();
                    }
                    //Perform Success Action
                })
                .catch((error) => {
                    // error.response.status Check status code
                }).finally(() => {
                //Perform action in always
            });
        },
        editSchedule(id) {
            this.isEditModalVisible = true;
            axios.get(this.$Template + '/' + id + '/edit', {
                headers: this.getAuthHeader(),
            })
                .then(res => {
                    if (res.status == 200) {
                       // console.log( res.data.result,'test');
                        this.scheduleForm = res.data.result.template;
                        this.getEmployeeByJobRoleId(this.scheduleForm.job_role_id);
                    }
                });
        },
        getEmployeeByJobRoleId(id) {

            axios.get(this.$GetEmployeesByJobRulesType, {
                headers: this.getAuthHeader(),
                params: {
                    job_role_id: id,
                    company_id: this.company_id,
                }
            })
                .then(res => {
                    if (res.data.status == 200) {
                        this.jobTypesEmployees = res.data.result;
                    }
                });
        },
        updateTemplate(id,day) {
            axios.put(this.$Template + '/' + id,
                {
                    day: day,
                    start_time: this.scheduleForm.start_time,
                    end_time: this.scheduleForm.end_time,
                    break_time: this.scheduleForm.break_time,
                    job_role_id: this.scheduleForm.job_role_id,
                    employee_id: this.scheduleForm.employee_id,
                    company_id: this.company_id,
                    comment: this.scheduleForm.comment,
                }, {headers: this.getAuthHeader()})
                .then((res) => {
                    if (res.status == 200) {
                        this.isEditModalVisible = false;
                        this.getAll();
                    }

                    //Perform Success Action
                })
                .catch((error) => {
                    // error.response.status Check status code
                }).finally(() => {
                //Perform action in always
            });
        },
        deleteSchedule(id) {
            if (confirm("Do you really want to delete?")) {
                axios.delete(this.$Template + '/' + id,
                    {headers: this.getAuthHeader()})
                    .then((res) => {
                        if (res.status == 200) {
                            this.isEditModalVisible = false;
                            this.getAll();
                        }
                    })
                    .catch((error) => {
                        // error.response.status Check status code
                    }).finally(() => {
                    //Perform action in always
                });
            }
        },
        getAll() {
            let params = {
                company_id: this.company_id,
            };
            this.$axios.get(this.$Template, {
                params: params,
                headers: this.getAuthHeader(),
            }).then(response => {
                this.weeksDatesFun();
                this.schedule = response.data.result.tempaltes;
                this.weeksDates.forEach(wd => {
                    this.newarrayTemplate[wd] = [];
                    this.schedule.forEach(sc => {
                        if (wd == sc.day) {
                            //this.schedule_ids.push(sc.id);
                            this.newarrayTemplate[wd].push(sc);
                        }
                    });
                });
            }).catch(error => {
                console.log(error);
            });
            //console.log('mainend');
        }


    }
  }
</script>
<style>
  .table td.schedule-td:hover .cardWrapperCus {
    display: block;
    background: rgba(0, 119, 156, 0.2);
    border-radius: 10px;
  }

  .card-wrapper.cardWrapperCus {
    display: none;
  }

  .btn {
    position: reltive;
  }

  .icoCopyByDate {
    font-size: 15px;
    margin-left: 10px;
    color: black;
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    opacity: 0;
    transition: all .25s linear;
  }

  .btn:hover .icoCopyByDate {
    display: inline-block;
    vertical-align: middle;
    opacity: 1;
  }


  .schedule-td:hover .inner-td-wrp .copy-days {
    display: block;
  }



</style>
